import * as types from './Types'

const initialState = {
    fetchTable: {},
    loading: true
}

export const offlineMasterReducers = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case types.TABLE_FETCH_AGAIN: return {
            ...state,
            fetchTable: payload,
            loading: false
        }

        case types.EMPTY_OFFLINE_STORE_DATA:
            return {
                ...state,
                fetchTable: initialState.fetchTable
            }
        default:
            return state
    }
}

export default offlineMasterReducers